export const TOURNAMENT_FORMATS = {
  8: { placePoints: [16, 12, 10, 9, 7, 6, 4, 3], recommendedBudget: 67, label: '8 Places' },
  6: { placePoints: [16, 12, 9, 7, 5, 3], recommendedBudget: 70, label: '6 Places' },
  4: { placePoints: [10, 7, 4, 2], recommendedBudget: 46, label: '4 Places' },
};

export type TournamentFormatKey = keyof typeof TOURNAMENT_FORMATS;
